<template>
  <!-- <v-app> -->

<!-- Add nav side bar .................................................................................!-->

  <div style="height:100%; width:100%; display:flex; flex-direction:row;">

  <v-navigation-drawer class="drawer_width" permanent>

      <v-list-item-group class="pa-0"> 

        <v-tooltip right>

          <template v-slot:activator="{ on, attrs }">

            <v-list-item 
            v-bind="attrs"
            v-on="on"
            mandatory
            @click="toTop(); $router.go(-1)">

              <v-list-item-icon>
                <v-icon>mdi-arrow-left</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="body-2">Back to cameras</v-list-item-title>
              </v-list-item-content>


             </v-list-item>


            <!--<v-list-item 
            v-bind="attrs"
            v-on="on"
            mandatory
            @click="toTop(); $router.go(-1)">

              <v-list-item-icon>
                <v-icon>mdi-arrow-left</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="body-2">Video Editing</v-list-item-title>
              </v-list-item-content>


             </v-list-item>-->

          </template>

          <span class="body-2">Back to inductions</span>

        </v-tooltip>

        <v-divider></v-divider>

      </v-list-item-group>

      <!-- List using v-for .......................................................................!-->
      
      

    </v-navigation-drawer>

    

  <!-- Page Content ...............................................................................!-->

      <v-row class="grey lighten-5">

        <v-col class="pt-0" cols="12" >

          <v-container style="max-width:900px">

              
          
      <div id='form-container'>
      



        <v-row justify="center">
          <v-col
            cols="6"
            md="4"
            >
            
          <v-date-picker ref="picker" v-model="date" :picker-date.sync="pickerDate" :max="maxDate" :min="minDate"
          
          ></v-date-picker>
          
          </v-col>

          <v-col
          cols ="12"
          md="8"
          >
           <v-card
      elevation="1"
      max-width="600"
      class="mx-auto"
      
    >
      <v-virtual-scroll
        
        :items="items"
        height="375"
        item-height="60"
      >
        <template v-slot:default="{ item }" >
          <v-list-item :key="item.name" @click="selectImage(item)" v-model="selectedItem">
            <v-list-item-action>
              <v-btn
                fab
                small
                depressed
                color="primary"
                
              >

                {{ item.name }}
              </v-btn>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>
                <strong> {{ item.time }}</strong>
              </v-list-item-title>
            </v-list-item-content>

        
          </v-list-item>

          <v-divider></v-divider>
        </template>
      </v-virtual-scroll>
    </v-card>
          </v-col>

        

        </v-row>
       
       
     <v-card
     class="py-10"> 
     <v-col>
    <v-row justify="center">
       <v-img
       :src="image"
       max-width="800"
       max-height="800"
       >
       <template v-slot:placeholder>
       <v-row
        align="center"
        justify="center"
        >
        
       <v-progress-circular
       indeterminate
       color = "grey"
       >
       </v-progress-circular>
       </v-row>
       </template>
       </v-img>
       
       </v-row>
       <v-card-text>{{imageTime}}</v-card-text>
       
      <v-btn
       @click="downloadImage()"
       elevation="1"
       
       >Download Image
       </v-btn> 
     </v-col>
       </v-card>
       <!-- table -->
       
      <!-- <v-card
     class="py-10"> 
     <v-col>
       
    <v-row justify="center">
      <v-col cols="6">
       <v-img
       :src="controlImage"
       max-width="800"
       max-height="800"
       >
       <template v-slot:placeholder>
       <v-row
        align="center"
        justify="center"
        >
        
       <v-progress-circular
       indeterminate
       color = "grey"
       >
       </v-progress-circular>
       </v-row>
       </template>
       </v-img>
       </v-col>
       
       <v-col cols="6">
       <v-img
       :src="newImage"
       max-width="800"
       max-height="800"
       >
       <template v-slot:placeholder>
       <v-row
        align="center"
        justify="center"
        >
        
       <v-progress-circular
       indeterminate
       color = "grey"
       >
       </v-progress-circular>
       </v-row>
       </template>
       </v-img>
       </v-col>

       </v-row>
       <v-card-text>Comparing {{comparing}}</v-card-text>
       <v-btn
       @click="compareBtn()"
       elevation="1"
       
       >Compare {{notComparing}} images
       </v-btn>
       <v-card-text>{{lastEdit}} vs {{editStart}}</v-card-text>
       
       <br><br>
       <v-btn
       @click="rejectImage()"
       elevation="1"
       
       >Not different
       </v-btn>
       <v-btn
       @click="acceptImage()"
       elevation="1"
       
       >Different
       </v-btn>
     </v-col>
       </v-card>-->

       <!--<v-card-text>wanted day list = {{wantedDayList}}</v-card-text>
       <v-card-text>day we are looking at = {{dayTesting}}</v-card-text>
       <v-card-text>hours we're looking at = {{hourSetterOne}} vs {{hourSetterTwo}}</v-card-text>
       <v-card-text>hourly images to compare = {{hourlyImages}}</v-card-text>
       <v-card-text>wanted hour list = {{wantedHourList}}</v-card-text>-->

        <!-- End Of Induction ......................................................................................................-->




      </div>

          </v-container>

        </v-col>

      </v-row>

  </div>



</template>

<script>
import { cameraCollection, editCollection } from '@/firebase'
import { storage } from '@/firebase'
import { mapState } from 'vuex'
import moment from 'moment'


var accessURL = ''

export default {
  components:{
    //AddSiteDetails,
    //AddPersonnel
  },

  data: () => ({
    
      sites: [],
      siteData: {},
      images: [],
      items: [],
      headers:[
        {text:'time', value:'name'}
      ], 
      benched: 0,
      selectedItem: '',
      pickerDate: null,
      date: '',
      image: "src=https://bad.src/not/valid",
      imageTime: "",
      imageUrl: "",
      minDate: "",
      maxDate: "",
      editStart: "",
      editEnd: "",
      dataset:{},
      
      firstPass: [],
      secondPass: [],
      controlImage: "",
      newImage: "",
      lastEdit: "",
      comparing: "days",
      notComparing: "hours",
      dayImage: null,
      hourImageList:[],

      fileDates: [],
      daySetterOne: "",
      daySetterTwo: "",
      hourSetterOne: "",
      hourSetterTwo: "",
      wantedDayList: [],
      wantedHourList: {},
      dayTesting: "",
      hourlyImages: [],

      photoDate:""
      
         
  }),

  watch: {
    date(){
      var dateArray = this.date.split('-')
      //alert(dateArray)
      this.photoDate = this.date
      var numArray = []
      dateArray.forEach(element => numArray.push(parseInt(element)))
      this.getFileList(numArray)
    },

    //this updates the date converters when the array of date values change.
    fileDates(){
      console.log('running comparer')
      try{
      //comapre start date to date array
      var lastEdit = this.daySetterOne.toString()
      
      var index = this.fileDates.indexOf(lastEdit)

      this.daySetterTwo = this.fileDates[index+1]
      
      }catch{}
    },

    daySetterOne(){

      var lastEdit = this.daySetterOne

      var year = lastEdit.slice(0,4)
      var month = lastEdit.slice(4,6)
      var day = lastEdit.slice(6,8)
      
      if(month[0] == 0){
        var month = month[1]
      }
      if(day[0] == 0){
        var day = day[1]
      }

      var cameraID = this.$route.query.site
      var storageRef = storage.ref()
      storageRef.child(`${cameraID}/lowRes/${year}/${month}/${day}/12-00.jpg`).getDownloadURL()
      .then((url)=>{
        this.controlImage = url
      }).catch((error)=>{
        alert(error)
        console.log(error)
      }) 



    },

    daySetterTwo(){

      var editStart = this.daySetterTwo

      var year = editStart.slice(0,4)
      var month = editStart.slice(4,6)
      var day = editStart.slice(6,8)

      if(month[0] == 0){
        var month = month[1]
      }
      if(day[0] == 0){
        var day = day[1]
      }

      var cameraID = this.$route.query.site
      var storageRef = storage.ref()
      storageRef.child(`${cameraID}/lowRes/${year}/${month}/${day}/12-00.jpg`).getDownloadURL()
      .then((url)=>{
        this.newImage = url
      }).catch((error)=>{
        alert(error)
        console.log(error)
      }) 

    },

    hourSetterOne(){

      var date = this.dayTesting;
      var hour = this.hourSetterOne;

      var year = date.slice(0,4);
      var month = date.slice(4,6);
      var day = date.slice(6,8);

      if(month[0] == 0){
        var month = month[1]
      }
      if(day[0] == 0){
        var day = day[1]
      }

      var cameraID = this.$route.query.site
      var storageRef = storage.ref()
      storageRef.child(`${cameraID}/lowRes/${year}/${month}/${day}/${hour}`).getDownloadURL()
      .then((url)=>{
        
        this.controlImage = url
      }).catch((error)=>{
        alert(error)
        console.log(error)
      }) 


    },


    hourSetterTwo(){

      
      var date = this.dayTesting;
      var hour = this.hourSetterTwo;

      var year = date.slice(0,4);
      var month = date.slice(4,6);
      var day = date.slice(6,8);

      if(month[0] == 0){
        var month = month[1]
      }
      if(day[0] == 0){
        var day = day[1]
      }

      var cameraID = this.$route.query.site
      var storageRef = storage.ref()
      storageRef.child(`${cameraID}/lowRes/${year}/${month}/${day}/${hour}`).getDownloadURL()
      .then((url)=>{
        
        this.newImage = url
      }).catch((error)=>{
        alert(error)
        console.log(error)
      }) 
    },

  },

  computed: {

      //map state
    ...mapState(['userProfile', 'posts', 'userRole']),

  },
  
  methods: {

    //compare hourly button triggers this
    compareBtn() {
      if(this.comparing == "hours"){
        this.comparing = "days";
        this.notComparing = "hours"
      }else{
        this.comparing = "hours";
        this.notComparing = "days";
        this.compareHoursSetup();
        this.generateFileStructure();
      }
     
    },

    async downloadImage(){
      const imageSrc = this.image
      const date = this.photoDate
      //alert(date)
      const time = this.imageTime
      //alert(time)

      var dateArray = date.split('-')

      var year = dateArray[0]
      var month = dateArray[1]
      var day = dateArray[2]

      if(month[0] == 0){
        var month = month[1]
      }
      if(day[0] == 0){
        var day = day[1]
      }

      var timeArray = time.split('.')

      var hour = timeArray[0]
      var minute = timeArray[1]

      if(hour.length == 1){
        var hour = `0${hour}`
      }

      //alert(month)
      //alert(day)
      

      var cameraID = this.$route.query.site
      var path = `${cameraID}/highRes/${year}/${month}/${day}/${hour}-${minute}.jpg`
      //alert(path)
      storage.ref(path).getDownloadURL()
      


      .then((url)=>{
    //     console.log(url)
    //     var xhr = new XMLHttpRequest();
    // xhr.responseType = 'blob';
    // xhr.onload = (event) => {
    //   var blob = xhr.response;
    // };
    // xhr.open('GET', url);
    // xhr.send();
    // console.log('downloaded?')
      const link = document.createElement('a')
      link.href = url
      link.download = 'image file name here'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    
      }).catch((error)=>{
        alert(error)
        console.log(error)
      }) 

      // const image = await fetch(imageSrc)
      // const imageBlog = await image.blob()
      // const imageURL = URL.createObjectURL(imageBlog)

      // const link = document.createElement('a')
      // link.href = url
      // link.download = 'image file name here'
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)

    },

    selectImage(value){
      
      this.image = value.src
      this.imageTime = value.time
    },

    initalFileCall() {
      var date = new Date();
      var year = date.getFullYear()
      var month = date.getMonth()+1
      var day = date.getDate()
      var dateArray = [year, month, day]
      this.photoDate = `${year}-${month}-${day}`
      this.getFileList(dateArray)
    },

  nextDayImage(){

    //take get current photo and update new compared one
    var daySetterOne = this.daySetterOne.toString()  
    var index = this.fileDates.indexOf(daySetterOne)
    this.daySetterTwo = this.fileDates[index+1]

  },

  nextHourImage(){

    var currentImage = this.hourSetterOne.toString()
    var index = this.hourlyImages.indexOf(currentImage)
    this.hourSetterTwo = this.hourlyImages[index+1]

  },

  // ------ TO DO
  // make accept image recognise if it's the last image in current dataset, take this from reject image.
  // update reject image to work with hourly images


  //runs after accepting btn pressed
  acceptImage(){
    //for days
    if(this.comparing == 'days'){
      //add day to wanted day list
      this.wantedDayList.push(this.daySetterTwo);
      //move 2nd image to 1st image
      this.daySetterOne = this.daySetterTwo;
      //get new 2nd day image
      this.nextDayImage();
    }
    //for hours
    else{
      var date = this.dayTesting;
      var hour = this.hourSetterTwo

      var hour = hour.slice(0,2);

      var year = date.slice(0,4);
      var month = date.slice(4,6);
      var day = date.slice(6,8);
      
      if(month[0] == 0){
        var month = month[1]
      }
      if(day[0] == 0){
        var day = day[1]
      }

      this.wantedHourList[year][month][day].push(hour)

      var currentImage = this.hourSetterTwo.toString();
      var index = this.hourlyImages.indexOf(currentImage);

      if(currentImage == this.hourlyImages[this.hourlyImages.length-1]){
        alert('last hour processed, getting next set of hours')
        //need to do this
        //check if we are on last day
        if(this.dayTesting == this.wantedDayList[this.wantedDayList.length-1]){
          alert('this is the last day during our hour editing')
          //enable download button?
        }else{
          var dayIndex = this.wantedDayList.indexOf(this.dayTesting);
          var newDay = this.wantedDayList[dayIndex+1]

          //this is not perfect, ideally we'd hold the last image of the previous day and compare.

          this.getHourImages(newDay);

        }
      }else{
        //move 2nd image to 1st image
        this.hourSetterOne = this.hourSetterTwo;

        //get new 2nd image
        this.nextHourImage();
      }


     

    }
  },

  rejectImage(){
    //for days
    if(this.comparing == "days"){
      var currentImage = this.daySetterTwo.toString()
      
      var index = this.fileDates.indexOf(currentImage)

      if(currentImage == this.fileDates[this.fileDates.length-1]){
        alert('last day processed, please switch to hour processing')
        
      }else{
        this.daySetterTwo = this.fileDates[index+1]
      }
    }
    //for hours    
    else{
      var currentImage = this.hourSetterTwo.toString();
      var index = this.hourlyImages.indexOf(currentImage);

      if(currentImage == this.hourlyImages[this.hourlyImages.length-1]){
        alert('last hour processed, getting next set of hours')
        //need to do this
        //check if we are on last day
        if(this.dayTesting == this.wantedDayList[this.wantedDayList.length-1]){
          alert('this is the last day during our hour editing')
          //enable download button?
        }else{
          var dayIndex = this.wantedDayList.indexOf(this.dayTesting);
          var newDay = this.wantedDayList[dayIndex+1]

          //this is not perfect, ideally we'd hold the last image of the previous day and compare.

          this.getHourImages(newDay);

        }
      }else{
        this.hourSetterTwo = this.hourlyImages[index+1]
      }

    }
   
  },

 async generateFileStructure(){

    var values = this.wantedDayList;

    var dataset = {}

    values.forEach((date) =>{
      
      let year = date.slice(0,4);
      var month = date.slice(4,6);
      var day = date.slice(6,8);

      if(month[0] == 0){
        var month = month[1]
      }
      if(day[0] == 0){
        var day = day[1]
      }

      //if year is not in dataset
      if(!dataset.hasOwnProperty(year)){
        dataset[year] = {[month]:{[day]:[]}}
      }else{
        if(!dataset[year].hasOwnProperty(month)){
          dataset[year][month] = {[day]:[]}
        }else{
          dataset[year][month][day] = []
        }
      }

      this.wantedHourList = dataset

    })

    

  },

  async compareHoursSetup(){
    //get first day value in list - 
    var firstDay = this.wantedDayList[0];
    alert(firstDay)

    //get list of hourly images in day folder
    this.getHourImages(firstDay)
    //
  },

  async getHourImages(date){

    this.dayTesting = date;

    var cameraID = this.$route.query.site;
    var listRef = storage.ref();

    var year = date.slice(0,4);
    var month = date.slice(4,6);
    var day = date.slice(6,8);

    if(day[0] == '0'){
      day = day[1]
    }
    if(month[0] == '0'){
      month = month[1]
    }

    console.log(`day value ${day}`)

    var childRef = listRef.child(`${cameraID}/lowRes/${year}/${month}/${day}`);

    this.items = []

    var hours = [];

    this.hourlyImages = [];

    childRef.listAll()
      .then((res) =>{

          console.log(res)

          res.items.forEach((itemRef) =>{
            var name = itemRef.name
            console.log(name);
            var hour = name.split('-')[0]
            console.log(`hour: ${hour}`)
            if (hours.includes(hour)){
              
            }else{
          
              hours.push(hour)
              this.hourlyImages.push(name)
               
            }

          })

          this.hourSetterOne = this.hourlyImages[0];
          this.hourSetterTwo = this.hourlyImages[1];
        
      })
    


  },
    
  async getFileList(dateArray) {
          
      var cameraID = this.$route.query.site
      var listRef = storage.ref()
      var childRef = listRef.child(`${cameraID}/lowRes/${dateArray[0]}/${dateArray[1]}/${dateArray[2]}`)
      
      this.items = []

      childRef.listAll()
        .then((res) => {
          return new Promise((resolve, reject) => {

            res.items.forEach((itemRef) => {
              //console.log(itemRef.name)
              itemRef.getDownloadURL()
              .then((url)=>{
                //console.log(url)
                var time = itemRef.name.replace(/\.[^/.]+$/, "")
                var time = parseFloat(time.replace(/-/g, '.')).toFixed(2)
                //console.log(time)
                this.items.push({'src':url, 'name':itemRef.name, 'time':time})
                this.items.sort(function(a,b){
                  return a.time - b.time 
                })
                
                if (this.items.length == res.items.length){
                  resolve('hello')
                }
              })
            
            
            })
          
            
          });
          
        }).then((res)=>{
          //console.log(res)
          this.image = this.items[this.items.length -1].src
          this.imageTime = this.items[this.items.length -1].time
          
        })
        .catch((error) => {
          console.log(error)
        })

    },
   
    async initialEditingSetup(){
    
      //Getting the last editing date
      const editsRef = editCollection.doc(this.$route.query.site)
      const doc = await editsRef.get()
      
      if (!doc.exists) {
            alert('Couldnt find edit data!');
           
        } else {
            let lastEditSeconds = doc.data().lastEdit.seconds
            this.dataset = doc.data().dataset
            
            let lastEditDate = new Date(lastEditSeconds*1000)

            var year = lastEditDate.getUTCFullYear()
            var month = lastEditDate.getUTCMonth() +1
            var date = lastEditDate.getUTCDate()

            if(month.toString().length == 1){
              var month = `0${month}`
            }

            if(date.toString().length == 1){
              var date = `0${date}`
            }

            let lastEditString = `${year}${month}${date}`

            this.daySetterOne = lastEditString

            //------------------------------------------//

            //get list of available dates
            var cameraID = this.$route.query.site
            var listRef = storage.ref()
            var filesRef = listRef.child(`${cameraID}/lowRes/`)
           
            // Find all the prefixes and items.
            filesRef.listAll()
            .then((res) => {
              res.prefixes.forEach((yearRef) => {
              const year = yearRef.name
              
              //get all the year folders
              yearRef.listAll()
                .then((res)=>{
                   
                res.prefixes.forEach((monthRef)=>{
                  //console.log(monthRef.name)

                  var monthName = monthRef.name

                    if (monthName.length == 1){
                      var monthName = `0${monthRef.name}`
                    }
                      const month = monthName

                  
                  //this.fileDates.year.push(month)
                  monthRef.listAll()
                  .then((res)=>{
                    res.prefixes.forEach((dayRef) =>{
                      //console.log(dayRef)
                      var dayName = dayRef.name

                      if (dayName.length == 1){
                        var dayName = `0${dayRef.name}`
                      }
                      const day = dayName

                      let yearStr = year.toString()
                      let monthStr = month.toString()
                      let dayStr = day.toString()
                      
                      this.fileDates.push(`${yearStr}${monthStr}${dayStr}`)
                      this.fileDates.sort()
                      
                      dayRef.listAll()

                      .then((res)=>{
                        res.items.forEach((itemRef) =>{
                        })
                      })
                    })
                  }).catch((error)=>{console.log(error)})
                }).catch((error)=>{console.log(error)})    
              }).catch((error)=>{console.log(error)}) 
            }).catch((error)=>{console.log(error)})
              
          }).catch((error) => {});
            console.log(JSON.stringify(this.fileDates));
          }
    },


    onFileChange(file) {
      try{
      this.url = URL.createObjectURL(file)
      }catch{
        this.url = null
      }
    },

    toTop () {
      this.$vuetify.goTo(0)
    },


    async getCamera() {
      const inductionRef = cameraCollection.doc(this.$route.query.site)
      const doc = await inductionRef.get()
      
      if (!doc.exists) {
            alert('Couldnt find site data!');
        } else {
            this.siteData = doc.data()
            this.minDate = new Date(doc.data().startDate.seconds * 1000).toISOString().replace(/T.*/,'').split('-').join('-')
            this.maxDate = new Date().toISOString().replace(/T.*/,'').split('-').join('-')
            
          }
    },

    uploadFile(target, name){

      var siteID = this.$route.query.site

      var accessRef = siteStorage.child(siteID +'/'+name+'.jpg')

      accessRef.put(target).then((snapshot) => {
        alert('file uploaded')
    })

    },

  },


  beforeMount(){
    this.getCamera()
    this.initalFileCall()
    this.initialEditingSetup()
  },

  
  
  filters: {
    formatDate(val) {
      if (!val) { return '-' }

      let date = val.toDate()
      return moment(date).fromNow()
    },
    trimLength(val) {
      if (val.length < 200) { return val }
      return `${val.substring(0, 200)}...`
    }
  },
  

    
}
</script>

<style lang="scss" scoped>

</style>


<!--

1. Get date of when footage was edited up to
2. Get dates when photos were taken after last edit date

3. Create array of yearmonthday that has images
4. Get first item in array, try to get image 12:00
otherwise get number of images in that folder, find centre image, grab the url for that image

5. display images 



-->